class IngredientsSection extends HTMLElement {
  constructor() {
    super();
    this.activeBenefit = null;
    this.activePage = 1;
    // Defensive: check if data-ingredients-info exists and is valid JSON
    const infoScript = this.querySelector('[data-ingredients-info]');
    try {
      this.items = infoScript ? JSON.parse(infoScript.textContent) : [];
    } catch (e) {
      this.items = [];
      console.error('Invalid ingredients info JSON', e);
    }
    this.nav = this.querySelector('.ingredients-section__nav');
    this.grid = this.querySelector('.ingredients-section__grid');
    this.filtersBtns = this.querySelectorAll('.ingredients-section__nav-item');
    this.cards = this.querySelectorAll('.ingredient-card');
    this.paginationContainer = null;
  }

  connectedCallback() {
    this.filterItems(this.activeBenefit);
    this.paginate();
    this.renderPagination();
    this.attachPaginationHandlers();
    // Use event delegation for filter buttons
    if (this.nav) {
      this.nav.addEventListener('click', (e) => {
        const button = e.target.closest('.ingredients-section__nav-item');
        if (!button || !this.nav.contains(button)) return;
        e.preventDefault();
        const benefit = button.getAttribute('data-benefit');

        if (button.classList.contains('active')) {
          this.activeBenefit = null;
          this.activePage = 1;
          this.filterItems(this.activeBenefit);
          this.handleButtonActive(null);
          this.paginate();
          this.renderPagination();
          this.attachPaginationHandlers();
          return;
        }
        if (benefit !== this.activeBenefit) {
          this.activeBenefit = benefit;
        }
        this.activePage = 1; // Reset to first page on filter change
        this.filterItems(this.activeBenefit);
        this.handleButtonActive(button);
        this.paginate();
        this.renderPagination();
        this.attachPaginationHandlers();
      });
    }
  }

  filterItems(activeFilter = null) {
    let visibleIndex = 0;
    this.cards.forEach(card => {
      const benefitsAttr = card.getAttribute('data-benefits');
      if (!benefitsAttr) return;
      const cardBenefits = new Set(benefitsAttr.split(','));
      const shouldHide = activeFilter && !cardBenefits.has(activeFilter);
      card.classList.toggle('card-hidden', !!shouldHide);
      if (!shouldHide) {
        visibleIndex++;
        const page = Math.ceil(visibleIndex / 15);
        card.setAttribute('data-pagination-page', page);
      } else {
        card.removeAttribute('data-pagination-page');
      }
    });
  }

  handleButtonActive(activeButton) {
    this.filtersBtns.forEach(btn => {
      if (btn === activeButton) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  paginate() {
    this.activeCards = Array.from(this.cards).filter(card => !card.classList.contains('card-hidden'));
    this.pages = Math.ceil(this.activeCards.length / 15) || 1;
    this.activeCards.forEach(card => {
      const page = Number(card.getAttribute('data-pagination-page'));
      if (page !== this.activePage) {
        card.classList.add('pagination-hidden');
      } else {
        card.classList.remove('pagination-hidden');
      }
    });
  }

  renderPagination() {
    if (this.paginationContainer) this.paginationContainer.remove();
    this.paginationContainer = document.createElement('div');
    this.paginationContainer.classList.add('pagination-container', 'page-width');
    if (this.pages === 1) this.paginationContainer.classList.add('pagination-hidden');
    this.grid.insertAdjacentElement('afterend', this.paginationContainer);
    for (let i = 1; i <= this.pages; i++) {
      const button = document.createElement('button');
      button.classList.add('pagination-button');
      if (i === this.activePage) {
        button.classList.add('active');
      }
      button.textContent = i;
      this.paginationContainer.appendChild(button);
    }
  }

  attachPaginationHandlers() {
    if (!this.paginationContainer) return;
    const buttons = this.paginationContainer.querySelectorAll('.pagination-button');
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        this.grid.scrollIntoView({ behavior: 'smooth' });
        this.activePage = parseInt(button.textContent);
        this.paginate();
        buttons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
      });
    });
  }
}

window.customElements.define('ingredients-section', IngredientsSection);